import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTeacherSubjectForm from "../../forms/CreateOrUpdateTeacherSubjectForm";
import { TeacherSubjectResponseDto } from "../../shared/dtos/teacherSubject/TeacherSubjectResponseDto";

interface UpdateTeacherSubjectModalProps {
  open: boolean;
  onClose: () => void;
  teacherSubject: TeacherSubjectResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateTeacherSubjectModal: React.FC<UpdateTeacherSubjectModalProps> = ({
  open,
  onClose,
  teacherSubject,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Allocation: ${teacherSubject?.teacherName || ""}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTeacherSubjectForm
      isEditing={true}
      teacherSubject={teacherSubject}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateTeacherSubjectModal;
